import React from 'react';
import { useAuth } from '../../context/AuthContext';

const Header: React.FC = () => {
  const { user, logout, isAuthenticated } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-2">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <h1 className="text-3xl font-bold">
              <a href="/dashboard" className="hover:opacity-80 transition-opacity">
              <img 
                src="/images/qfm-logo.png" 
                alt="QFM Resources" 
                className="h-12"
              />
              </a>
            </h1>
          </div>
          
          <nav className="flex items-center space-x-4">
            {isAuthenticated ? (
              <div className="flex items-center space-x-4">
                {user?.role === 'admin' ? (
                  <span className="text-gray-500 text-sm">Logged in as: {user?.name} ({user?.role})</span>
                ) : (
                  <div className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                    {user?.name} - {user?.organization?.name || 'No Organization'}
                  </div>
                )}
                <button
                  onClick={logout}
                  className="text-gray-600 hover:text-gray-900 font-medium text-sm"
                >
                  Logout
                </button>
              </div>
            ) : (
              <a href="/login" className="btn-primary">
                Login
              </a>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;